import {useRemoteData} from '../../common/utils/useRemoteData';
import {getSelfDetails} from '../infrastructure/UserApi';

export const useSelfDetails = () => {
  const userDetailsRemoteData = useRemoteData({ initialData: null, dataFetchingCallback: getSelfDetails });
  return { userDetailsRemoteData };
};